import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  TextareaAutosize,
  Typography,
} from '@mui/material'
import {
  clearMessage,
  downloadDnsFile,
  resetDnsGeneration,
} from '../../../store/AdditionalTools/actionCreator'
import { DnsErrorModal } from './DnsErrorModal'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../../Utils/FireFlyVnextHelpers'

export class DnsExcelGenerationTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonEnabled: false,
      dnsErrorMessage: '',
      dnsErrorOpen: false,
      dnsFileData: '',
      dnsFileName: '',
      locations: '',
    }
    this.createRtm = this.createRtm.bind(this)
    this.fileDownload = React.createRef()
    this.handleErrorModalClose = this.handleErrorModalClose.bind(this)
    this.resetForm = this.resetForm.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.dnsFileData !== nextProps.dnsFileData &&
      nextProps.dnsFileData !== '' &&
      nextProps.dnsFileData != null
    ) {
      const url = window.URL.createObjectURL(nextProps.dnsFileData)
      this.setState(
        {
          dnsFileData: url,
          dnsFileName: nextProps.dnsFileName,
        },
        function () {
          this.fileDownload.current.click()
        },
      )
    }
    if (this.props.dnsErrorMessage !== nextProps.dnsErrorMessage) {
      this.setState({
        dnsErrorMessage: nextProps.dnsErrorMessage,
        dnsErrorOpen: nextProps.dnsErrorOpen,
      })
    }
  }

  componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'DNS Excel Generation Tab',
        'DNS Excel Generation Tab Load',
        userInfo,
      )
    }
  }

  createRtm = (event) => {
    const { userInfo } = this.props
    handleFireflySendClickEvent(
      'CLICK',
      'DNS Excel Generation Tab',
      'DNS Excel Generation - Submit',
      userInfo,
    )
    event.preventDefault()
    this.props.clearMessage()
    const filteredLocations = this.state.locations
      .split(/[\s,]+/)
      .filter((id) => id.trim() !== '')
      .join(' ')
    this.props.downloadDnsFile(filteredLocations)
    this.resetForm()
  }

  handleErrorModalClose = () => {
    this.props.resetDnsGeneration()
  }

  resetForm = () => {
    this.setState({
      buttonEnabled: false,
      locations: '',
    })
  }

  validateForm = () => {
    const hasLocations =
      this.state.locations.split(/[\s,]+/).filter((id) => id.trim() !== '')
        .length > 0
    this.setState({ buttonEnabled: hasLocations })
  }

  render() {
    return (
      <CardContent
        style={{
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        <CardActions style={{ width: '100%' }}>
          <Grid
            item
            size={{ xs: 12 }}
            style={{
              marginTop: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography gutterBottom>
              Enter the locations you wish to create the DNS RTM file for.
            </Typography>
          </Grid>
        </CardActions>
        <form
          onSubmit={this.createRtm}
          style={{
            alignItems: 'stretch',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid
            container
            style={{
              width: '100%',
              height: '100%',
              alignItems: 'stretch',
              display: 'flex',
            }}
          >
            <Grid container item style={{ paddingLeft: 8, width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  paddingTop: '10px',
                  flexBasis: '500px',
                }}
              >
                <FormControl style={{ width: '100%' }}>
                  <TextareaAutosize
                    htmlFor="locations"
                    type="text"
                    minRows={10}
                    maxRows={18}
                    value={this.state.locations}
                    placeholder="Enter Locations (Ex: T0003 T0004 ETC)"
                    label="Locations"
                    required
                    onChange={(event) =>
                      this.setState(
                        { locations: event.target.value },
                        function () {
                          this.validateForm()
                        },
                      )
                    }
                    style={{ width: '100%' }}
                  />
                </FormControl>
                <CardActions
                  style={{
                    width: '100%',
                    height: '30%',
                  }}
                >
                  <Grid
                    item
                    size={{ xs: 12 }}
                    style={{
                      marginTop: 20,
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'start',
                    }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={!this.state.buttonEnabled}
                    >
                      Submit
                    </Button>
                  </Grid>
                </CardActions>
              </div>
            </Grid>
          </Grid>
        </form>
        <DnsErrorModal
          open={this.state.dnsErrorOpen}
          handleClose={this.handleErrorModalClose}
          message={this.state.dnsErrorMessage}
          clearMessage={this.props.clearMessage}
        />
        <a
          href={this.state.dnsFileData}
          download={this.state.dnsFileName}
          ref={this.fileDownload}
          style={{ display: 'none' }}
        >
          ''
        </a>
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dnsErrorMessage: state.additionalTools.dnsErrorMessage,
    dnsErrorOpen: state.additionalTools.dnsErrorOpen,
    dnsFileData: state.additionalTools.dnsFileData,
    dnsFileName: state.additionalTools.dnsFileName,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  clearMessage,
  downloadDnsFile,
  resetDnsGeneration,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DnsExcelGenerationTab)
